/* eslint-disable camelcase */
/* eslint-disable no-var */
import moment from 'moment';

        export var timezones = {
            '-720,0': 'Etc/GMT+12',
            '-660,0': 'Pacific/Pago_Pago',
            '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
            '-600,1': 'America/Adak',
            '-600,0': 'Pacific/Honolulu',
            '-570,0': 'Pacific/Marquesas',
            '-540,0': 'Pacific/Gambier',
            '-540,1': 'America/Anchorage',
            '-480,1': 'America/Los_Angeles',
            '-480,0': 'Pacific/Pitcairn',
            '-420,0': 'America/Phoenix',
            '-420,1': 'America/Denver',
            '-360,0': 'America/Guatemala',
            '-360,1': 'America/Chicago',
            '-360,1,s': 'Pacific/Easter',
            '-300,0': 'America/Bogota',
            '-300,1': 'America/New_York',
            '-270,0': 'America/Caracas',
            '-240,1': 'America/Halifax',
            '-240,0': 'America/Santo_Domingo',
            '-240,1,s': 'America/Asuncion',
            '-210,1': 'America/St_Johns',
            '-180,1': 'America/Godthab',
            '-180,0': 'America/Argentina/Buenos_Aires',
            '-180,1,s': 'America/Montevideo',
            '-120,0': 'America/Noronha',
            '-120,1': 'America/Noronha',
            '-60,1': 'Atlantic/Azores',
            '-60,0': 'Atlantic/Cape_Verde',
            '0,0': 'UTC',
            '0,1': 'Europe/London',
            '60,1': 'Europe/Berlin',
            '60,0': 'Africa/Lagos',
            '60,1,s': 'Africa/Windhoek',
            '120,1': 'Asia/Beirut',
            '120,0': 'Africa/Johannesburg',
            '180,0': 'Asia/Baghdad',
            '180,1': 'Europe/Moscow',
            '210,1': 'Asia/Tehran',
            '240,0': 'Asia/Dubai',
            '240,1': 'Asia/Baku',
            '270,0': 'Asia/Kabul',
            '300,1': 'Asia/Yekaterinburg',
            '300,0': 'Asia/Karachi',
            '330,0': 'Asia/Kolkata',
            '345,0': 'Asia/Kathmandu',
            '360,0': 'Asia/Dhaka',
            '360,1': 'Asia/Omsk',
            '390,0': 'Asia/Rangoon',
            '420,1': 'Asia/Krasnoyarsk',
            '420,0': 'Asia/Jakarta',
            '480,0': 'Asia/Shanghai',
            '480,1': 'Asia/Irkutsk',
            '525,0': 'Australia/Eucla',
            '525,1,s': 'Australia/Eucla',
            '540,1': 'Asia/Yakutsk',
            '540,0': 'Asia/Tokyo',
            '570,0': 'Australia/Darwin',
            '570,1,s': 'Australia/Adelaide',
            '600,0': 'Australia/Brisbane',
            '600,1': 'Asia/Vladivostok',
            '600,1,s': 'Australia/Sydney',
            '630,1,s': 'Australia/Lord_Howe',
            '660,1': 'Asia/Kamchatka',
            '660,0': 'Pacific/Noumea',
            '690,0': 'Pacific/Norfolk',
            '720,1,s': 'Pacific/Auckland',
            '720,0': 'Pacific/Majuro',
            '765,1,s': 'Pacific/Chatham',
            '780,0': 'Pacific/Tongatapu',
            '780,1,s': 'Pacific/Apia',
            '840,0': 'Pacific/Kiritimati'
        };
        export var dst_rules = {
            'years': [
                2008,
                2009,
                2010,
                2011,
                2012,
                2013,
                2014
            ],
            'zones': [
                {
                    'name': 'Africa/Cairo',
                    'rules': [
                        {
                            'e': 1219957200000,
                            's': 1209074400000
                        },
                        {
                            'e': 1250802000000,
                            's': 1240524000000
                        },
                        {
                            'e': 1285880400000,
                            's': 1284069600000
                        },
                        false,
                        false,
                        false,
                        {
                            'e': 1411678800000,
                            's': 1406844000000
                        }
                    ]
                },
                {
                    'name': 'Africa/Casablanca',
                    'rules': [
                        {
                            'e': 1220223600000,
                            's': 1212278400000
                        },
                        {
                            'e': 1250809200000,
                            's': 1243814400000
                        },
                        {
                            'e': 1281222000000,
                            's': 1272758400000
                        },
                        {
                            'e': 1312066800000,
                            's': 1301788800000
                        },
                        {
                            'e': 1348970400000,
                            's': 1345428000000
                        },
                        {
                            'e': 1382839200000,
                            's': 1376100000000
                        },
                        {
                            'e': 1414288800000,
                            's': 1406944800000
                        }
                    ]
                },
                {
                    'name': 'America/Asuncion',
                    'rules': [
                        {
                            'e': 1205031600000,
                            's': 1224388800000
                        },
                        {
                            'e': 1236481200000,
                            's': 1255838400000
                        },
                        {
                            'e': 1270954800000,
                            's': 1286078400000
                        },
                        {
                            'e': 1302404400000,
                            's': 1317528000000
                        },
                        {
                            'e': 1333854000000,
                            's': 1349582400000
                        },
                        {
                            'e': 1364094000000,
                            's': 1381032000000
                        },
                        {
                            'e': 1395543600000,
                            's': 1412481600000
                        }
                    ]
                },
                {
                    'name': 'America/Campo_Grande',
                    'rules': [
                        {
                            'e': 1203217200000,
                            's': 1224388800000
                        },
                        {
                            'e': 1234666800000,
                            's': 1255838400000
                        },
                        {
                            'e': 1266721200000,
                            's': 1287288000000
                        },
                        {
                            'e': 1298170800000,
                            's': 1318737600000
                        },
                        {
                            'e': 1330225200000,
                            's': 1350792000000
                        },
                        {
                            'e': 1361070000000,
                            's': 1382241600000
                        },
                        {
                            'e': 1392519600000,
                            's': 1413691200000
                        }
                    ]
                },
                {
                    'name': 'America/Goose_Bay',
                    'rules': [
                        {
                            'e': 1225594860000,
                            's': 1205035260000
                        },
                        {
                            'e': 1257044460000,
                            's': 1236484860000
                        },
                        {
                            'e': 1289098860000,
                            's': 1268539260000
                        },
                        {
                            'e': 1320555600000,
                            's': 1299988860000
                        },
                        {
                            'e': 1352005200000,
                            's': 1331445600000
                        },
                        {
                            'e': 1383454800000,
                            's': 1362895200000
                        },
                        {
                            'e': 1414904400000,
                            's': 1394344800000
                        }
                    ]
                },
                {
                    'name': 'America/Havana',
                    'rules': [
                        {
                            'e': 1224997200000,
                            's': 1205643600000
                        },
                        {
                            'e': 1256446800000,
                            's': 1236488400000
                        },
                        {
                            'e': 1288501200000,
                            's': 1268542800000
                        },
                        {
                            'e': 1321160400000,
                            's': 1300597200000
                        },
                        {
                            'e': 1352005200000,
                            's': 1333256400000
                        },
                        {
                            'e': 1383454800000,
                            's': 1362891600000
                        },
                        {
                            'e': 1414904400000,
                            's': 1394341200000
                        }
                    ]
                },
                {
                    'name': 'America/Mazatlan',
                    'rules': [
                        {
                            'e': 1225008000000,
                            's': 1207472400000
                        },
                        {
                            'e': 1256457600000,
                            's': 1238922000000
                        },
                        {
                            'e': 1288512000000,
                            's': 1270371600000
                        },
                        {
                            'e': 1319961600000,
                            's': 1301821200000
                        },
                        {
                            'e': 1351411200000,
                            's': 1333270800000
                        },
                        {
                            'e': 1382860800000,
                            's': 1365325200000
                        },
                        {
                            'e': 1414310400000,
                            's': 1396774800000
                        }
                    ]
                },
                {
                    'name': 'America/Mexico_City',
                    'rules': [
                        {
                            'e': 1225004400000,
                            's': 1207468800000
                        },
                        {
                            'e': 1256454000000,
                            's': 1238918400000
                        },
                        {
                            'e': 1288508400000,
                            's': 1270368000000
                        },
                        {
                            'e': 1319958000000,
                            's': 1301817600000
                        },
                        {
                            'e': 1351407600000,
                            's': 1333267200000
                        },
                        {
                            'e': 1382857200000,
                            's': 1365321600000
                        },
                        {
                            'e': 1414306800000,
                            's': 1396771200000
                        }
                    ]
                },
                {
                    'name': 'America/Miquelon',
                    'rules': [
                        {
                            'e': 1225598400000,
                            's': 1205038800000
                        },
                        {
                            'e': 1257048000000,
                            's': 1236488400000
                        },
                        {
                            'e': 1289102400000,
                            's': 1268542800000
                        },
                        {
                            'e': 1320552000000,
                            's': 1299992400000
                        },
                        {
                            'e': 1352001600000,
                            's': 1331442000000
                        },
                        {
                            'e': 1383451200000,
                            's': 1362891600000
                        },
                        {
                            'e': 1414900800000,
                            's': 1394341200000
                        }
                    ]
                },
                {
                    'name': 'America/Santa_Isabel',
                    'rules': [
                        {
                            'e': 1225011600000,
                            's': 1207476000000
                        },
                        {
                            'e': 1256461200000,
                            's': 1238925600000
                        },
                        {
                            'e': 1288515600000,
                            's': 1270375200000
                        },
                        {
                            'e': 1319965200000,
                            's': 1301824800000
                        },
                        {
                            'e': 1351414800000,
                            's': 1333274400000
                        },
                        {
                            'e': 1382864400000,
                            's': 1365328800000
                        },
                        {
                            'e': 1414314000000,
                            's': 1396778400000
                        }
                    ]
                },
                {
                    'name': 'America/Santiago',
                    'rules': [
                        {
                            'e': 1206846000000,
                            's': 1223784000000
                        },
                        {
                            'e': 1237086000000,
                            's': 1255233600000
                        },
                        {
                            'e': 1270350000000,
                            's': 1286683200000
                        },
                        {
                            'e': 1304823600000,
                            's': 1313899200000
                        },
                        {
                            'e': 1335668400000,
                            's': 1346558400000
                        },
                        {
                            'e': 1367118000000,
                            's': 1378612800000
                        },
                        {
                            'e': 1398567600000,
                            's': 1410062400000
                        }
                    ]
                },
                {
                    'name': 'America/Sao_Paulo',
                    'rules': [
                        {
                            'e': 1203213600000,
                            's': 1224385200000
                        },
                        {
                            'e': 1234663200000,
                            's': 1255834800000
                        },
                        {
                            'e': 1266717600000,
                            's': 1287284400000
                        },
                        {
                            'e': 1298167200000,
                            's': 1318734000000
                        },
                        {
                            'e': 1330221600000,
                            's': 1350788400000
                        },
                        {
                            'e': 1361066400000,
                            's': 1382238000000
                        },
                        {
                            'e': 1392516000000,
                            's': 1413687600000
                        }
                    ]
                },
                {
                    'name': 'Asia/Amman',
                    'rules': [
                        {
                            'e': 1225404000000,
                            's': 1206655200000
                        },
                        {
                            'e': 1256853600000,
                            's': 1238104800000
                        },
                        {
                            'e': 1288303200000,
                            's': 1269554400000
                        },
                        {
                            'e': 1319752800000,
                            's': 1301608800000
                        },
                        false,
                        false,
                        {
                            'e': 1414706400000,
                            's': 1395957600000
                        }
                    ]
                },
                {
                    'name': 'Asia/Damascus',
                    'rules': [
                        {
                            'e': 1225486800000,
                            's': 1207260000000
                        },
                        {
                            'e': 1256850000000,
                            's': 1238104800000
                        },
                        {
                            'e': 1288299600000,
                            's': 1270159200000
                        },
                        {
                            'e': 1319749200000,
                            's': 1301608800000
                        },
                        {
                            'e': 1351198800000,
                            's': 1333058400000
                        },
                        {
                            'e': 1382648400000,
                            's': 1364508000000
                        },
                        {
                            'e': 1414702800000,
                            's': 1395957600000
                        }
                    ]
                },
                {
                    'name': 'Asia/Dubai',
                    'rules': [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Gaza',
                    'rules': [
                        {
                            'e': 1219957200000,
                            's': 1206655200000
                        },
                        {
                            'e': 1252015200000,
                            's': 1238104800000
                        },
                        {
                            'e': 1281474000000,
                            's': 1269640860000
                        },
                        {
                            'e': 1312146000000,
                            's': 1301608860000
                        },
                        {
                            'e': 1348178400000,
                            's': 1333058400000
                        },
                        {
                            'e': 1380229200000,
                            's': 1364508000000
                        },
                        {
                            'e': 1414098000000,
                            's': 1395957600000
                        }
                    ]
                },
                {
                    'name': 'Asia/Irkutsk',
                    'rules': [
                        {
                            'e': 1224957600000,
                            's': 1206813600000
                        },
                        {
                            'e': 1256407200000,
                            's': 1238263200000
                        },
                        {
                            'e': 1288461600000,
                            's': 1269712800000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Jerusalem',
                    'rules': [
                        {
                            'e': 1223161200000,
                            's': 1206662400000
                        },
                        {
                            'e': 1254006000000,
                            's': 1238112000000
                        },
                        {
                            'e': 1284246000000,
                            's': 1269561600000
                        },
                        {
                            'e': 1317510000000,
                            's': 1301616000000
                        },
                        {
                            'e': 1348354800000,
                            's': 1333065600000
                        },
                        {
                            'e': 1382828400000,
                            's': 1364515200000
                        },
                        {
                            'e': 1414278000000,
                            's': 1395964800000
                        }
                    ]
                },
                {
                    'name': 'Asia/Kamchatka',
                    'rules': [
                        {
                            'e': 1224943200000,
                            's': 1206799200000
                        },
                        {
                            'e': 1256392800000,
                            's': 1238248800000
                        },
                        {
                            'e': 1288450800000,
                            's': 1269698400000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Krasnoyarsk',
                    'rules': [
                        {
                            'e': 1224961200000,
                            's': 1206817200000
                        },
                        {
                            'e': 1256410800000,
                            's': 1238266800000
                        },
                        {
                            'e': 1288465200000,
                            's': 1269716400000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Omsk',
                    'rules': [
                        {
                            'e': 1224964800000,
                            's': 1206820800000
                        },
                        {
                            'e': 1256414400000,
                            's': 1238270400000
                        },
                        {
                            'e': 1288468800000,
                            's': 1269720000000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Vladivostok',
                    'rules': [
                        {
                            'e': 1224950400000,
                            's': 1206806400000
                        },
                        {
                            'e': 1256400000000,
                            's': 1238256000000
                        },
                        {
                            'e': 1288454400000,
                            's': 1269705600000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Yakutsk',
                    'rules': [
                        {
                            'e': 1224954000000,
                            's': 1206810000000
                        },
                        {
                            'e': 1256403600000,
                            's': 1238259600000
                        },
                        {
                            'e': 1288458000000,
                            's': 1269709200000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Yekaterinburg',
                    'rules': [
                        {
                            'e': 1224968400000,
                            's': 1206824400000
                        },
                        {
                            'e': 1256418000000,
                            's': 1238274000000
                        },
                        {
                            'e': 1288472400000,
                            's': 1269723600000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Asia/Yerevan',
                    'rules': [
                        {
                            'e': 1224972000000,
                            's': 1206828000000
                        },
                        {
                            'e': 1256421600000,
                            's': 1238277600000
                        },
                        {
                            'e': 1288476000000,
                            's': 1269727200000
                        },
                        {
                            'e': 1319925600000,
                            's': 1301176800000
                        },
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Australia/Lord_Howe',
                    'rules': [
                        {
                            'e': 1207407600000,
                            's': 1223134200000
                        },
                        {
                            'e': 1238857200000,
                            's': 1254583800000
                        },
                        {
                            'e': 1270306800000,
                            's': 1286033400000
                        },
                        {
                            'e': 1301756400000,
                            's': 1317483000000
                        },
                        {
                            'e': 1333206000000,
                            's': 1349537400000
                        },
                        {
                            'e': 1365260400000,
                            's': 1380987000000
                        },
                        {
                            'e': 1396710000000,
                            's': 1412436600000
                        }
                    ]
                },
                {
                    'name': 'Australia/Perth',
                    'rules': [
                        {
                            'e': 1206813600000,
                            's': 1224957600000
                        },
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Europe/Helsinki',
                    'rules': [
                        {
                            'e': 1224982800000,
                            's': 1206838800000
                        },
                        {
                            'e': 1256432400000,
                            's': 1238288400000
                        },
                        {
                            'e': 1288486800000,
                            's': 1269738000000
                        },
                        {
                            'e': 1319936400000,
                            's': 1301187600000
                        },
                        {
                            'e': 1351386000000,
                            's': 1332637200000
                        },
                        {
                            'e': 1382835600000,
                            's': 1364691600000
                        },
                        {
                            'e': 1414285200000,
                            's': 1396141200000
                        }
                    ]
                },
                {
                    'name': 'Europe/Minsk',
                    'rules': [
                        {
                            'e': 1224979200000,
                            's': 1206835200000
                        },
                        {
                            'e': 1256428800000,
                            's': 1238284800000
                        },
                        {
                            'e': 1288483200000,
                            's': 1269734400000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Europe/Moscow',
                    'rules': [
                        {
                            'e': 1224975600000,
                            's': 1206831600000
                        },
                        {
                            'e': 1256425200000,
                            's': 1238281200000
                        },
                        {
                            'e': 1288479600000,
                            's': 1269730800000
                        },
                        false,
                        false,
                        false,
                        false
                    ]
                },
                {
                    'name': 'Pacific/Apia',
                    'rules': [
                        false,
                        false,
                        false,
                        {
                            'e': 1301752800000,
                            's': 1316872800000
                        },
                        {
                            'e': 1333202400000,
                            's': 1348927200000
                        },
                        {
                            'e': 1365256800000,
                            's': 1380376800000
                        },
                        {
                            'e': 1396706400000,
                            's': 1411826400000
                        }
                    ]
                },
                {
                    'name': 'Pacific/Fiji',
                    'rules': [
                        false,
                        false,
                        {
                            'e': 1269698400000,
                            's': 1287842400000
                        },
                        {
                            'e': 1327154400000,
                            's': 1319292000000
                        },
                        {
                            'e': 1358604000000,
                            's': 1350741600000
                        },
                        {
                            'e': 1390050000000,
                            's': 1382796000000
                        },
                        {
                            'e': 1421503200000,
                            's': 1414850400000
                        }
                    ]
                },
                {
                    'name': 'Europe/London',
                    'rules': [
                        {
                            'e': 1224982800000,
                            's': 1206838800000
                        },
                        {
                            'e': 1256432400000,
                            's': 1238288400000
                        },
                        {
                            'e': 1288486800000,
                            's': 1269738000000
                        },
                        {
                            'e': 1319936400000,
                            's': 1301187600000
                        },
                        {
                            'e': 1351386000000,
                            's': 1332637200000
                        },
                        {
                            'e': 1382835600000,
                            's': 1364691600000
                        },
                        {
                            'e': 1414285200000,
                            's': 1396141200000
                        }
                    ]
                }
            ]
        };


    var HEMISPHERE_SOUTH = 's';
        var consts = {
            DAY: 86400000,
            HOUR: 3600000,
            MINUTE: 60000,
            SECOND: 1000,
            BASELINE_YEAR: 2014,
            MAX_SCORE: 864000000, // 10 days
            AMBIGUITIES: {
                'America/Denver': ['America/Mazatlan'],
                'Europe/London': ['Africa/Casablanca'],
                'America/Chicago': ['America/Mexico_City'],
                'America/Asuncion': ['America/Campo_Grande', 'America/Santiago'],
                'America/Montevideo': ['America/Sao_Paulo', 'America/Santiago'],
                // Europe/Minsk should not be in this list... but Windows.
                'Asia/Beirut': ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
                'Pacific/Auckland': ['Pacific/Fiji'],
                'America/Los_Angeles': ['America/Santa_Isabel'],
                'America/New_York': ['America/Havana'],
                'America/Halifax': ['America/Goose_Bay'],
                'America/Godthab': ['America/Miquelon'],
                'Asia/Dubai': ['Asia/Yerevan'],
                'Asia/Jakarta': ['Asia/Krasnoyarsk'],
                'Asia/Shanghai': ['Asia/Irkutsk', 'Australia/Perth'],
                'Australia/Sydney': ['Australia/Lord_Howe'],
                'Asia/Tokyo': ['Asia/Yakutsk'],
                'Asia/Dhaka': ['Asia/Omsk'],
                // In the real world Yerevan is not ambigous for Baku... but Windows.
                'Asia/Baku': ['Asia/Yerevan'],
                'Australia/Brisbane': ['Asia/Vladivostok'],
                'Pacific/Noumea': ['Asia/Vladivostok'],
                'Pacific/Majuro': ['Asia/Kamchatka', 'Pacific/Fiji'],
                'Pacific/Tongatapu': ['Pacific/Apia'],
                'Asia/Baghdad': ['Europe/Minsk', 'Europe/Moscow'],
                'Asia/Karachi': ['Asia/Yekaterinburg'],
                'Africa/Johannesburg': ['Asia/Gaza', 'Africa/Cairo']
            }
        };

        var get_date_offset = function (date) {
            var offset = -date.getTimezoneOffset();

            return (offset !== null ? offset : 0);
        };

        /**
         * This function does some basic calculations to create information about
         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
         * the script has been tested rather than depend on the year set by the
         * client device.
         *
         * Returns a key that can be used to do lookups in jstz.olson.timezones.
         * eg: "720,1,2".
         *
         * @returns {String}
         */
        var lookup_key = function () {
            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2));
                var june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2));
                var diff = january_offset - june_offset;

            if (diff < 0) {
                return `${january_offset  },1`;
            } else if (diff > 0) {
                return `${june_offset  },1,${  HEMISPHERE_SOUTH}`;
            }

            return `${january_offset  },0`;
        };


        /**
         * Tries to get the time zone key directly from the operating system for those
         * environments that support the ECMAScript Internationalization API.
         */
        var get_from_internationalization_api = function () {
            try {
                var format; var timezone;

                if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat === 'undefined') {
                    return;
                }

                format = Intl.DateTimeFormat();

                if (typeof format === 'undefined' || typeof format.resolvedOptions === 'undefined') {
                    return;
                }

                timezone = format.resolvedOptions().timeZone;

                if (timezone && (timezone.indexOf('/') > -1 || timezone === 'UTC')) {
                    return timezone;
                }
            } catch (ex) {
                return false;
            }
        };

        /**
         * Starting point for getting all the DST rules for a specific year
         * for the current timezone (as described by the client system).
         *
         * Returns an object with start and end attributes, or false if no
         * DST rules were found for the year.
         *
         * @param year
         * @returns {Object} || {Boolean}
         */
        var dst_dates = function (year) {
            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
            var current = yearstart;
            var offset = (new Date(current)).getTimezoneOffset();
            var dst_start = null;
            var dst_end = null;

            while (current < yearend - 86400000) {
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

                if (dateToCheckOffset !== offset) {
                    if (dateToCheckOffset < offset) {
                        dst_start = dateToCheck;
                    }
                    if (dateToCheckOffset > offset) {
                        dst_end = dateToCheck;
                    }
                    offset = dateToCheckOffset;
                }

                current += 86400000;
            }

            if (dst_start && dst_end) {
                return {
                    s: find_dst_fold(dst_start).getTime(),
                    e: find_dst_fold(dst_end).getTime()
                };
            }

            return false;
        };

        /**
         * Probably completely unnecessary function that recursively finds the
         * exact (to the second) time when a DST rule was changed.
         *
         * @param a_date - The candidate Date.
         * @param padding - integer specifying the padding to allow around the candidate
         *                  date for finding the fold.
         * @param iterator - integer specifying how many milliseconds to iterate while
         *                   searching for the fold.
         *
         * @returns {Date}
         */
        var find_dst_fold = function (a_date, padding, iterator) {
            if (typeof padding === 'undefined') {
                padding = consts.DAY;
                iterator = consts.HOUR;
            }

            var date_start = new Date(a_date.getTime() - padding).getTime();
            var date_end = a_date.getTime() + padding;
            var offset = new Date(date_start).getTimezoneOffset();

            var current = date_start;

            var dst_change = null;

            while (current < date_end - iterator) {
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

                if (dateToCheckOffset !== offset) {
                    dst_change = dateToCheck;
                    break;
                }
                current += iterator;
            }

            if (padding === consts.DAY) {
                return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
            }

            if (padding === consts.HOUR) {
                return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
            }

            return dst_change;
        };

        var windows7_adaptations = function (rule_list, preliminary_timezone, score, sample) {
            if (score !== 'N/A') {
                return score;
            }
            if (preliminary_timezone === 'Asia/Beirut') {
                if (sample.name === 'Africa/Cairo') {
                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
                        return 0;
                    }
                }
                if (sample.name === 'Asia/Jerusalem') {
                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
                        return 0;
                    }
                }
            } else if (preliminary_timezone === 'America/Santiago') {
                if (sample.name === 'America/Asuncion') {
                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
                        return 0;
                    }
                }
                if (sample.name === 'America/Campo_Grande') {
                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
                        return 0;
                    }
                }
            } else if (preliminary_timezone === 'America/Montevideo') {
                if (sample.name === 'America/Sao_Paulo') {
                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
                        return 0;
                    }
                }
            } else if (preliminary_timezone === 'Pacific/Auckland') {
                if (sample.name === 'Pacific/Fiji') {
                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
                        return 0;
                    }
                }
            }

            return score;
        };

        /**
         * Takes the DST rules for the current timezone, and proceeds to find matches
         * in the jstz.olson.dst_rules.zones array.
         *
         * Compares samples to the current timezone on a scoring basis.
         *
         * Candidates are ruled immediately if either the candidate or the current zone
         * has a DST rule where the other does not.
         *
         * Candidates are ruled out immediately if the current zone has a rule that is
         * outside the DST scope of the candidate.
         *
         * Candidates are included for scoring if the current zones rules fall within the
         * span of the samples rules.
         *
         * Low score is best, the score is calculated by summing up the differences in DST
         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
         *
         * Yah follow? :)
         *
         * @param rule_list
         * @param preliminary_timezone
         * @returns {*}
         */
        var best_dst_match = function (rule_list, preliminary_timezone) {
            var score_sample = function score_sample(sample) {
                var score = 0;

                for (var j = 0; j < rule_list.length; j++) {
                    // Both sample and current time zone report DST during the year.
                    if (!!sample.rules[j] && !!rule_list[j]) {
                        // The current time zone's DST rules are inside the sample's. Include.
                        if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
                            score = 0;
                            score += Math.abs(rule_list[j].s - sample.rules[j].s);
                            score += Math.abs(sample.rules[j].e - rule_list[j].e);

                            // The current time zone's DST rules are outside the sample's. Discard.
                        } else {
                            score = 'N/A';
                            break;
                        }

                        // The max score has been reached. Discard.
                        if (score > consts.MAX_SCORE) {
                            score = 'N/A';
                            break;
                        }
                    }
                }

                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);

                return score;
            };
            var scoreboard = {};
            var dst_zones = dst_rules.zones;
            var dst_zones_length = dst_zones.length;
            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];

            for (var i = 0; i < dst_zones_length; i++) {
                var sample = dst_zones[i];
                var score = score_sample(dst_zones[i]);

                if (score !== 'N/A') {
                    scoreboard[sample.name] = score;
                }
            }

            for (var tz in scoreboard) {
                if (scoreboard.hasOwnProperty(tz)) {
                    for (var j = 0; j < ambiguities.length; j++) {
                        if (ambiguities[j] === tz) {
                            return tz;
                        }
                    }
                }
            }

            return preliminary_timezone;
        };

        /**
         * Takes the preliminary_timezone as detected by lookup_key().
         *
         * Builds up the current timezones DST rules for the years defined
         * in the jstz.olson.dst_rules.years array.
         *
         * If there are no DST occurences for those years, immediately returns
         * the preliminary timezone. Otherwise proceeds and tries to solve
         * ambiguities.
         *
         * @param preliminary_timezone
         * @returns {String} timezone_name
         */
        var get_by_dst = function (preliminary_timezone) {
            var get_rules = function get_rules() {
                var rule_list = [];

                for (var i = 0; i < dst_rules.years.length; i++) {
                    var year_rules = dst_dates(dst_rules.years[i]);

                    rule_list.push(year_rules);
                }
                return rule_list;
            };
            var check_has_dst = function check_has_dst(rules) {
                for (var i = 0; i < rules.length; i++) {
                    if (rules[i] !== false) {
                        return true;
                    }
                }
                return false;
            };
            var rules = get_rules();
            var has_dst = check_has_dst(rules);

            if (has_dst) {
                return best_dst_match(rules, preliminary_timezone);
            }

            return preliminary_timezone;
        };

    export function determine() {
        var preliminary_tz = get_from_internationalization_api();

        if (!preliminary_tz) {
            preliminary_tz = timezones[lookup_key()];

            if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
                preliminary_tz = get_by_dst(preliminary_tz);
            }
        }

        return {
            name() {
                return preliminary_tz;
            }
        };
    }

    /**
     * 当前电脑的tz*
     */
export var tzStar = determine().name();

var maps = { 'etc/gmt+12': 'Dateline Standard Time', 'etc/gmt+11': 'UTC-11', 'pacific/pago_pago': 'UTC-11', 'pacific/niue': 'UTC-11', 'pacific/midway': 'UTC-11', 'pacific/honolulu': 'Hawaiian Standard Time', 'pacific/rarotonga': 'Hawaiian Standard Time', 'pacific/tahiti': 'Hawaiian Standard Time', 'pacific/johnston': 'Hawaiian Standard Time', 'etc/gmt+10': 'Hawaiian Standard Time', 'america/anchorage': 'Alaskan Standard Time', 'america/juneau': 'Alaskan Standard Time', 'america/metlakatla': 'Alaskan Standard Time', 'america/nome': 'Alaskan Standard Time', 'america/sitka': 'Alaskan Standard Time', 'america/yakutat': 'Alaskan Standard Time', 'america/los_angeles': 'Pacific Standard Time', 'america/vancouver': 'Pacific Standard Time', 'america/dawson': 'Pacific Standard Time', 'america/whitehorse': 'Pacific Standard Time', 'america/tijuana': 'Pacific Standard Time', 'america/santa_isabel': 'Pacific Standard Time', 'pst8pdt': 'Pacific Standard Time', 'america/phoenix': 'US Mountain Standard Time', 'america/dawson_creek': 'US Mountain Standard Time', 'america/creston': 'US Mountain Standard Time', 'america/fort_nelson': 'US Mountain Standard Time', 'america/hermosillo': 'US Mountain Standard Time', 'etc/gmt+7': 'US Mountain Standard Time', 'america/chihuahua': 'Mountain Standard Time (Mexico)', 'america/mazatlan': 'Mountain Standard Time (Mexico)', 'america/denver': 'Mountain Standard Time', 'america/edmonton': 'Mountain Standard Time', 'america/cambridge_bay': 'Mountain Standard Time', 'america/inuvik': 'Mountain Standard Time', 'america/yellowknife': 'Mountain Standard Time', 'america/ojinaga': 'Mountain Standard Time', 'america/boise': 'Mountain Standard Time', 'mst7mdt': 'Mountain Standard Time', 'america/guatemala': 'Central America Standard Time', 'america/belize': 'Central America Standard Time', 'america/costa_rica': 'Central America Standard Time', 'pacific/galapagos': 'Central America Standard Time', 'america/tegucigalpa': 'Central America Standard Time', 'america/managua': 'Central America Standard Time', 'america/el_salvador': 'Central America Standard Time', 'etc/gmt+6': 'Central America Standard Time', 'america/chicago': 'Central Standard Time', 'america/winnipeg': 'Central Standard Time', 'america/rainy_river': 'Central Standard Time', 'america/rankin_inlet': 'Central Standard Time', 'america/resolute': 'Central Standard Time', 'america/matamoros': 'Central Standard Time', 'america/indiana/knox': 'Central Standard Time', 'america/indiana/tell_city': 'Central Standard Time', 'america/menominee': 'Central Standard Time', 'america/north_dakota/beulah': 'Central Standard Time', 'america/north_dakota/center': 'Central Standard Time', 'america/north_dakota/new_salem': 'Central Standard Time', 'cst6cdt': 'Central Standard Time', 'america/mexico_city': 'Central Standard Time (Mexico)', 'america/bahia_banderas': 'Central Standard Time (Mexico)', 'america/merida': 'Central Standard Time (Mexico)', 'america/monterrey': 'Central Standard Time (Mexico)', 'america/regina': 'Canada Central Standard Time', 'america/swift_current': 'Canada Central Standard Time', 'america/bogota': 'SA Pacific Standard Time', 'america/rio_branco': 'SA Pacific Standard Time', 'america/eirunepe': 'SA Pacific Standard Time', 'america/coral_harbour': 'SA Pacific Standard Time', 'pacific/easter': 'SA Pacific Standard Time', 'america/guayaquil': 'SA Pacific Standard Time', 'america/port-au-prince': 'SA Pacific Standard Time', 'america/jamaica': 'SA Pacific Standard Time', 'america/cayman': 'SA Pacific Standard Time', 'america/panama': 'SA Pacific Standard Time', 'america/lima': 'SA Pacific Standard Time', 'etc/gmt+5': 'SA Pacific Standard Time', 'america/cancun': 'Eastern Standard Time (Mexico)', 'america/new_york': 'Eastern Standard Time', 'america/nassau': 'Eastern Standard Time', 'america/toronto': 'Eastern Standard Time', 'america/iqaluit': 'Eastern Standard Time', 'america/montreal': 'Eastern Standard Time', 'america/nipigon': 'Eastern Standard Time', 'america/pangnirtung': 'Eastern Standard Time', 'america/thunder_bay': 'Eastern Standard Time', 'america/havana': 'Eastern Standard Time', 'america/detroit': 'Eastern Standard Time', 'america/indiana/petersburg': 'Eastern Standard Time', 'america/indiana/vincennes': 'Eastern Standard Time', 'america/indiana/winamac': 'Eastern Standard Time', 'america/kentucky/monticello': 'Eastern Standard Time', 'america/louisville': 'Eastern Standard Time', 'est5edt': 'Eastern Standard Time', 'america/indianapolis': 'US Eastern Standard Time', 'america/indiana/marengo': 'US Eastern Standard Time', 'america/indiana/vevay': 'US Eastern Standard Time', 'america/caracas': 'Venezuela Standard Time', 'america/asuncion': 'Paraguay Standard Time', 'america/halifax': 'Atlantic Standard Time', 'atlantic/bermuda': 'Atlantic Standard Time', 'america/glace_bay': 'Atlantic Standard Time', 'america/goose_bay': 'Atlantic Standard Time', 'america/moncton': 'Atlantic Standard Time', 'america/thule': 'Atlantic Standard Time', 'america/cuiaba': 'Central Brazilian Standard Time', 'america/campo_grande': 'Central Brazilian Standard Time', 'america/la_paz': 'SA Western Standard Time', 'america/antigua': 'SA Western Standard Time', 'america/anguilla': 'SA Western Standard Time', 'america/aruba': 'SA Western Standard Time', 'america/barbados': 'SA Western Standard Time', 'america/st_barthelemy': 'SA Western Standard Time', 'america/kralendijk': 'SA Western Standard Time', 'america/manaus': 'SA Western Standard Time', 'america/boa_vista': 'SA Western Standard Time', 'america/porto_velho': 'SA Western Standard Time', 'america/blanc-sablon': 'SA Western Standard Time', 'america/curacao': 'SA Western Standard Time', 'america/dominica': 'SA Western Standard Time', 'america/santo_domingo': 'SA Western Standard Time', 'america/grenada': 'SA Western Standard Time', 'america/guadeloupe': 'SA Western Standard Time', 'america/guyana': 'SA Western Standard Time', 'america/st_kitts': 'SA Western Standard Time', 'america/st_lucia': 'SA Western Standard Time', 'america/marigot': 'SA Western Standard Time', 'america/martinique': 'SA Western Standard Time', 'america/montserrat': 'SA Western Standard Time', 'america/puerto_rico': 'SA Western Standard Time', 'america/lower_princes': 'SA Western Standard Time', 'america/grand_turk': 'SA Western Standard Time', 'america/port_of_spain': 'SA Western Standard Time', 'america/st_vincent': 'SA Western Standard Time', 'america/tortola': 'SA Western Standard Time', 'america/st_thomas': 'SA Western Standard Time', 'etc/gmt+4': 'SA Western Standard Time', 'america/st_johns': 'Newfoundland Standard Time', 'america/sao_paulo': 'E. South America Standard Time', 'america/cayenne': 'SA Eastern Standard Time', 'antarctica/rothera': 'SA Eastern Standard Time', 'america/fortaleza': 'SA Eastern Standard Time', 'america/araguaina': 'SA Eastern Standard Time', 'america/belem': 'SA Eastern Standard Time', 'america/maceio': 'SA Eastern Standard Time', 'america/recife': 'SA Eastern Standard Time', 'america/santarem': 'SA Eastern Standard Time', 'atlantic/stanley': 'SA Eastern Standard Time', 'america/paramaribo': 'SA Eastern Standard Time', 'etc/gmt+3': 'SA Eastern Standard Time', 'america/buenos_aires': 'Argentina Standard Time', 'america/argentina/la_rioja': 'Argentina Standard Time', 'america/argentina/rio_gallegos': 'Argentina Standard Time', 'america/argentina/salta': 'Argentina Standard Time', 'america/argentina/san_juan': 'Argentina Standard Time', 'america/argentina/san_luis': 'Argentina Standard Time', 'america/argentina/tucuman': 'Argentina Standard Time', 'america/argentina/ushuaia': 'Argentina Standard Time', 'america/catamarca': 'Argentina Standard Time', 'america/cordoba': 'Argentina Standard Time', 'america/jujuy': 'Argentina Standard Time', 'america/mendoza': 'Argentina Standard Time', 'america/godthab': 'Greenland Standard Time', 'america/montevideo': 'Montevideo Standard Time', 'america/bahia': 'Bahia Standard Time', 'america/santiago': 'Pacific SA Standard Time', 'antarctica/palmer': 'Pacific SA Standard Time', 'etc/gmt+2': 'UTC-02', 'america/noronha': 'UTC-02', 'atlantic/south_georgia': 'UTC-02', 'atlantic/azores': 'Azores Standard Time', 'america/scoresbysund': 'Azores Standard Time', 'atlantic/cape_verde': 'Cape Verde Standard Time', 'etc/gmt+1': 'Cape Verde Standard Time', 'africa/casablanca': 'Morocco Standard Time', 'africa/el_aaiun': 'Morocco Standard Time', 'etc/gmt': 'UTC', 'america/danmarkshavn': 'UTC', 'europe/london': 'GMT Standard Time', 'atlantic/canary': 'GMT Standard Time', 'atlantic/faeroe': 'GMT Standard Time', 'europe/guernsey': 'GMT Standard Time', 'europe/dublin': 'GMT Standard Time', 'europe/isle_of_man': 'GMT Standard Time', 'europe/jersey': 'GMT Standard Time', 'europe/lisbon': 'GMT Standard Time', 'atlantic/madeira': 'GMT Standard Time', 'atlantic/reykjavik': 'Greenwich Standard Time', 'africa/ouagadougou': 'Greenwich Standard Time', 'africa/abidjan': 'Greenwich Standard Time', 'africa/accra': 'Greenwich Standard Time', 'africa/banjul': 'Greenwich Standard Time', 'africa/conakry': 'Greenwich Standard Time', 'africa/bissau': 'Greenwich Standard Time', 'africa/monrovia': 'Greenwich Standard Time', 'africa/bamako': 'Greenwich Standard Time', 'africa/nouakchott': 'Greenwich Standard Time', 'atlantic/st_helena': 'Greenwich Standard Time', 'africa/freetown': 'Greenwich Standard Time', 'africa/dakar': 'Greenwich Standard Time', 'africa/sao_tome': 'Greenwich Standard Time', 'africa/lome': 'Greenwich Standard Time', 'europe/berlin': 'W. Europe Standard Time', 'europe/andorra': 'W. Europe Standard Time', 'europe/vienna': 'W. Europe Standard Time', 'europe/zurich': 'W. Europe Standard Time', 'europe/busingen': 'W. Europe Standard Time', 'europe/gibraltar': 'W. Europe Standard Time', 'europe/rome': 'W. Europe Standard Time', 'europe/vaduz': 'W. Europe Standard Time', 'europe/luxembourg': 'W. Europe Standard Time', 'europe/monaco': 'W. Europe Standard Time', 'europe/malta': 'W. Europe Standard Time', 'europe/amsterdam': 'W. Europe Standard Time', 'europe/oslo': 'W. Europe Standard Time', 'europe/stockholm': 'W. Europe Standard Time', 'arctic/longyearbyen': 'W. Europe Standard Time', 'europe/san_marino': 'W. Europe Standard Time', 'europe/vatican': 'W. Europe Standard Time', 'europe/budapest': 'Central Europe Standard Time', 'europe/tirane': 'Central Europe Standard Time', 'europe/prague': 'Central Europe Standard Time', 'europe/podgorica': 'Central Europe Standard Time', 'europe/belgrade': 'Central Europe Standard Time', 'europe/ljubljana': 'Central Europe Standard Time', 'europe/bratislava': 'Central Europe Standard Time', 'europe/paris': 'Romance Standard Time', 'europe/brussels': 'Romance Standard Time', 'europe/copenhagen': 'Romance Standard Time', 'europe/madrid': 'Romance Standard Time', 'africa/ceuta': 'Romance Standard Time', 'europe/warsaw': 'Central European Standard Time', 'europe/sarajevo': 'Central European Standard Time', 'europe/zagreb': 'Central European Standard Time', 'europe/skopje': 'Central European Standard Time', 'africa/lagos': 'W. Central Africa Standard Time', 'africa/luanda': 'W. Central Africa Standard Time', 'africa/porto-novo': 'W. Central Africa Standard Time', 'africa/kinshasa': 'W. Central Africa Standard Time', 'africa/bangui': 'W. Central Africa Standard Time', 'africa/brazzaville': 'W. Central Africa Standard Time', 'africa/douala': 'W. Central Africa Standard Time', 'africa/algiers': 'W. Central Africa Standard Time', 'africa/libreville': 'W. Central Africa Standard Time', 'africa/malabo': 'W. Central Africa Standard Time', 'africa/niamey': 'W. Central Africa Standard Time', 'africa/ndjamena': 'W. Central Africa Standard Time', 'africa/tunis': 'W. Central Africa Standard Time', 'etc/gmt-1': 'W. Central Africa Standard Time', 'africa/windhoek': 'Namibia Standard Time', 'asia/amman': 'Jordan Standard Time', 'europe/bucharest': 'GTB Standard Time', 'asia/nicosia': 'GTB Standard Time', 'europe/athens': 'GTB Standard Time', 'asia/beirut': 'Middle East Standard Time', 'africa/cairo': 'Egypt Standard Time', 'asia/damascus': 'Syria Standard Time', 'europe/chisinau': 'E. Europe Standard Time', 'africa/johannesburg': 'South Africa Standard Time', 'africa/bujumbura': 'South Africa Standard Time', 'africa/gaborone': 'South Africa Standard Time', 'africa/lubumbashi': 'South Africa Standard Time', 'africa/maseru': 'South Africa Standard Time', 'africa/blantyre': 'South Africa Standard Time', 'africa/maputo': 'South Africa Standard Time', 'africa/kigali': 'South Africa Standard Time', 'africa/mbabane': 'South Africa Standard Time', 'africa/lusaka': 'South Africa Standard Time', 'africa/harare': 'South Africa Standard Time', 'etc/gmt-2': 'South Africa Standard Time', 'europe/kiev': 'FLE Standard Time', 'europe/mariehamn': 'FLE Standard Time', 'europe/sofia': 'FLE Standard Time', 'europe/tallinn': 'FLE Standard Time', 'europe/helsinki': 'FLE Standard Time', 'europe/vilnius': 'FLE Standard Time', 'europe/riga': 'FLE Standard Time', 'europe/uzhgorod': 'FLE Standard Time', 'europe/zaporozhye': 'FLE Standard Time', 'europe/istanbul': 'Turkey Standard Time', 'asia/jerusalem': 'Israel Standard Time', 'europe/kaliningrad': 'Kaliningrad Standard Time', 'africa/tripoli': 'Libya Standard Time', 'asia/baghdad': 'Arabic Standard Time', 'asia/riyadh': 'Arab Standard Time', 'asia/bahrain': 'Arab Standard Time', 'asia/kuwait': 'Arab Standard Time', 'asia/qatar': 'Arab Standard Time', 'asia/aden': 'Arab Standard Time', 'europe/minsk': 'Belarus Standard Time', 'europe/moscow': 'Russian Standard Time', 'europe/simferopol': 'Russian Standard Time', 'europe/volgograd': 'Russian Standard Time', 'africa/nairobi': 'E. Africa Standard Time', 'antarctica/syowa': 'E. Africa Standard Time', 'africa/djibouti': 'E. Africa Standard Time', 'africa/asmera': 'E. Africa Standard Time', 'africa/addis_ababa': 'E. Africa Standard Time', 'indian/comoro': 'E. Africa Standard Time', 'indian/antananarivo': 'E. Africa Standard Time', 'africa/khartoum': 'E. Africa Standard Time', 'africa/mogadishu': 'E. Africa Standard Time', 'africa/juba': 'E. Africa Standard Time', 'africa/dar_es_salaam': 'E. Africa Standard Time', 'africa/kampala': 'E. Africa Standard Time', 'indian/mayotte': 'E. Africa Standard Time', 'etc/gmt-3': 'E. Africa Standard Time', 'asia/tehran': 'Iran Standard Time', 'asia/dubai': 'Arabian Standard Time', 'asia/muscat': 'Arabian Standard Time', 'etc/gmt-4': 'Arabian Standard Time', 'asia/baku': 'Azerbaijan Standard Time', 'europe/samara': 'Russia Time Zone 3', 'europe/astrakhan': 'Russia Time Zone 3', 'europe/ulyanovsk': 'Russia Time Zone 3', 'indian/mauritius': 'Mauritius Standard Time', 'indian/reunion': 'Mauritius Standard Time', 'indian/mahe': 'Mauritius Standard Time', 'asia/tbilisi': 'Georgian Standard Time', 'asia/yerevan': 'Caucasus Standard Time', 'asia/kabul': 'Afghanistan Standard Time', 'asia/tashkent': 'West Asia Standard Time', 'antarctica/mawson': 'West Asia Standard Time', 'asia/oral': 'West Asia Standard Time', 'asia/aqtau': 'West Asia Standard Time', 'asia/aqtobe': 'West Asia Standard Time', 'indian/maldives': 'West Asia Standard Time', 'indian/kerguelen': 'West Asia Standard Time', 'asia/dushanbe': 'West Asia Standard Time', 'asia/ashgabat': 'West Asia Standard Time', 'asia/samarkand': 'West Asia Standard Time', 'etc/gmt-5': 'West Asia Standard Time', 'asia/yekaterinburg': 'Ekaterinburg Standard Time', 'asia/karachi': 'Pakistan Standard Time', 'asia/calcutta': 'India Standard Time', 'asia/colombo': 'Sri Lanka Standard Time', 'asia/katmandu': 'Nepal Standard Time', 'asia/almaty': 'Central Asia Standard Time', 'antarctica/vostok': 'Central Asia Standard Time', 'asia/urumqi': 'Central Asia Standard Time', 'indian/chagos': 'Central Asia Standard Time', 'asia/bishkek': 'Central Asia Standard Time', 'asia/qyzylorda': 'Central Asia Standard Time', 'etc/gmt-6': 'Central Asia Standard Time', 'asia/dhaka': 'Bangladesh Standard Time', 'asia/thimphu': 'Bangladesh Standard Time', 'asia/novosibirsk': 'N. Central Asia Standard Time', 'asia/omsk': 'N. Central Asia Standard Time', 'asia/rangoon': 'Myanmar Standard Time', 'indian/cocos': 'Myanmar Standard Time', 'asia/bangkok': 'SE Asia Standard Time', 'antarctica/davis': 'SE Asia Standard Time', 'indian/christmas': 'SE Asia Standard Time', 'asia/jakarta': 'SE Asia Standard Time', 'asia/pontianak': 'SE Asia Standard Time', 'asia/phnom_penh': 'SE Asia Standard Time', 'asia/vientiane': 'SE Asia Standard Time', 'asia/saigon': 'SE Asia Standard Time', 'etc/gmt-7': 'SE Asia Standard Time', 'asia/krasnoyarsk': 'North Asia Standard Time', 'asia/barnaul': 'North Asia Standard Time', 'asia/novokuznetsk': 'North Asia Standard Time', 'asia/shanghai': 'China Standard Time', 'asia/hong_kong': 'China Standard Time', 'asia/macau': 'China Standard Time', 'asia/irkutsk': 'North Asia East Standard Time', 'asia/singapore': 'Singapore Standard Time', 'asia/brunei': 'Singapore Standard Time', 'asia/makassar': 'Singapore Standard Time', 'asia/kuala_lumpur': 'Singapore Standard Time', 'asia/kuching': 'Singapore Standard Time', 'asia/manila': 'Singapore Standard Time', 'etc/gmt-8': 'Singapore Standard Time', 'australia/perth': 'W. Australia Standard Time', 'antarctica/casey': 'W. Australia Standard Time', 'asia/taipei': 'Taipei Standard Time', 'asia/ulaanbaatar': 'Ulaanbaatar Standard Time', 'asia/choibalsan': 'Ulaanbaatar Standard Time', 'asia/pyongyang': 'North Korea Standard Time', 'asia/tokyo': 'Tokyo Standard Time', 'asia/jayapura': 'Tokyo Standard Time', 'pacific/palau': 'Tokyo Standard Time', 'asia/dili': 'Tokyo Standard Time', 'etc/gmt-9': 'Tokyo Standard Time', 'asia/seoul': 'Korea Standard Time', 'asia/yakutsk': 'Yakutsk Standard Time', 'asia/chita': 'Yakutsk Standard Time', 'asia/khandyga': 'Yakutsk Standard Time', 'australia/adelaide': 'Cen. Australia Standard Time', 'australia/broken_hill': 'Cen. Australia Standard Time', 'australia/darwin': 'AUS Central Standard Time', 'australia/brisbane': 'E. Australia Standard Time', 'australia/lindeman': 'E. Australia Standard Time', 'australia/sydney': 'AUS Eastern Standard Time', 'australia/melbourne': 'AUS Eastern Standard Time', 'pacific/port_moresby': 'West Pacific Standard Time', 'antarctica/dumontdurville': 'West Pacific Standard Time', 'pacific/truk': 'West Pacific Standard Time', 'pacific/guam': 'West Pacific Standard Time', 'pacific/saipan': 'West Pacific Standard Time', 'etc/gmt-10': 'West Pacific Standard Time', 'australia/hobart': 'Tasmania Standard Time', 'australia/currie': 'Tasmania Standard Time', 'asia/magadan': 'Magadan Standard Time', 'asia/vladivostok': 'Vladivostok Standard Time', 'asia/ust-nera': 'Vladivostok Standard Time', 'asia/srednekolymsk': 'Russia Time Zone 10', 'asia/sakhalin': 'Russia Time Zone 10', 'pacific/guadalcanal': 'Central Pacific Standard Time', 'antarctica/macquarie': 'Central Pacific Standard Time', 'pacific/ponape': 'Central Pacific Standard Time', 'pacific/kosrae': 'Central Pacific Standard Time', 'pacific/noumea': 'Central Pacific Standard Time', 'pacific/norfolk': 'Central Pacific Standard Time', 'pacific/bougainville': 'Central Pacific Standard Time', 'pacific/efate': 'Central Pacific Standard Time', 'etc/gmt-11': 'Central Pacific Standard Time', 'asia/kamchatka': 'Russia Time Zone 11', 'asia/anadyr': 'Russia Time Zone 11', 'pacific/auckland': 'New Zealand Standard Time', 'antarctica/mcmurdo': 'New Zealand Standard Time', 'etc/gmt-12': 'UTC+12', 'pacific/tarawa': 'UTC+12', 'pacific/majuro': 'UTC+12', 'pacific/kwajalein': 'UTC+12', 'pacific/nauru': 'UTC+12', 'pacific/funafuti': 'UTC+12', 'pacific/wake': 'UTC+12', 'pacific/wallis': 'UTC+12', 'pacific/fiji': 'Fiji Standard Time', 'pacific/tongatapu': 'Tonga Standard Time', 'pacific/enderbury': 'Tonga Standard Time', 'pacific/fakaofo': 'Tonga Standard Time', 'etc/gmt-13': 'Tonga Standard Time', 'pacific/apia': 'Samoa Standard Time', 'pacific/kiritimati': 'Line Islands Standard Time', 'etc/gmt-14': 'Line Islands Standard Time' };

maps.timezones = [{ 'id': 'Dateline Standard Time', 'name': '(UTC-12:00) International Date Line West', 'utcOffset': -720 }, { 'id': 'UTC-11', 'name': '(UTC-11:00) Coordinated Universal Time-11', 'utcOffset': -660 }, { 'id': 'Hawaiian Standard Time', 'name': '(UTC-10:00) Hawaii', 'utcOffset': -600 }, { 'id': 'Alaskan Standard Time', 'name': '(UTC-09:00) Alaska', 'utcOffset': -540 }, { 'id': 'Pacific Standard Time (Mexico)', 'name': '(UTC-08:00) Baja California', 'utcOffset': -480 }, { 'id': 'Pacific Standard Time', 'name': '(UTC-08:00) Pacific Time (US & Canada)', 'utcOffset': -480 }, { 'id': 'US Mountain Standard Time', 'name': '(UTC-07:00) Arizona', 'utcOffset': -420 }, { 'id': 'Mountain Standard Time (Mexico)', 'name': '(UTC-07:00) Chihuahua, La Paz, Mazatlan', 'utcOffset': -420 }, { 'id': 'Mountain Standard Time', 'name': '(UTC-07:00) Mountain Time (US & Canada)', 'utcOffset': -420 }, { 'id': 'Central America Standard Time', 'name': '(UTC-06:00) Central America', 'utcOffset': -360 }, { 'id': 'Central Standard Time', 'name': '(UTC-06:00) Central Time (US & Canada)', 'utcOffset': -360 }, { 'id': 'Central Standard Time (Mexico)', 'name': '(UTC-06:00) Guadalajara, Mexico City, Monterrey', 'utcOffset': -360 }, { 'id': 'Canada Central Standard Time', 'name': '(UTC-06:00) Saskatchewan', 'utcOffset': -360 }, { 'id': 'SA Pacific Standard Time', 'name': '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', 'utcOffset': -300 }, { 'id': 'Eastern Standard Time (Mexico)', 'name': '(UTC-05:00) Chetumal', 'utcOffset': -300 }, { 'id': 'Eastern Standard Time', 'name': '(UTC-05:00) Eastern Time (US & Canada)', 'utcOffset': -300 }, { 'id': 'US Eastern Standard Time', 'name': '(UTC-05:00) Indiana (East)', 'utcOffset': -300 }, { 'id': 'Venezuela Standard Time', 'name': '(UTC-04:30) Caracas', 'utcOffset': -270 }, { 'id': 'Paraguay Standard Time', 'name': '(UTC-04:00) Asuncion', 'utcOffset': -240 }, { 'id': 'Atlantic Standard Time', 'name': '(UTC-04:00) Atlantic Time (Canada)', 'utcOffset': -240 }, { 'id': 'Central Brazilian Standard Time', 'name': '(UTC-04:00) Cuiaba', 'utcOffset': -240 }, { 'id': 'SA Western Standard Time', 'name': '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', 'utcOffset': -240 }, { 'id': 'Newfoundland Standard Time', 'name': '(UTC-03:30) Newfoundland', 'utcOffset': -210 }, { 'id': 'E. South America Standard Time', 'name': '(UTC-03:00) Brasilia', 'utcOffset': -180 }, { 'id': 'Argentina Standard Time', 'name': '(UTC-03:00) Buenos Aires', 'utcOffset': -180 }, { 'id': 'SA Eastern Standard Time', 'name': '(UTC-03:00) Cayenne, Fortaleza', 'utcOffset': -180 }, { 'id': 'Greenland Standard Time', 'name': '(UTC-03:00) Greenland', 'utcOffset': -180 }, { 'id': 'Montevideo Standard Time', 'name': '(UTC-03:00) Montevideo', 'utcOffset': -180 }, { 'id': 'Bahia Standard Time', 'name': '(UTC-03:00) Salvador', 'utcOffset': -180 }, { 'id': 'Pacific SA Standard Time', 'name': '(UTC-03:00) Santiago', 'utcOffset': -180 }, { 'id': 'UTC-02', 'name': '(UTC-02:00) Coordinated Universal Time-02', 'utcOffset': -120 }, { 'id': 'Mid-Atlantic Standard Time', 'name': '(UTC-02:00) Mid-Atlantic - Old', 'utcOffset': -120 }, { 'id': 'Azores Standard Time', 'name': '(UTC-01:00) Azores', 'utcOffset': -60 }, { 'id': 'Cape Verde Standard Time', 'name': '(UTC-01:00) Cabo Verde Is.', 'utcOffset': -60 }, { 'id': 'Morocco Standard Time', 'name': '(UTC) Casablanca', 'utcOffset': 0 }, { 'id': 'UTC', 'name': '(UTC) Coordinated Universal Time', 'utcOffset': 0 }, { 'id': 'GMT Standard Time', 'name': '(UTC) Dublin, Edinburgh, Lisbon, London', 'utcOffset': 0 }, { 'id': 'Greenwich Standard Time', 'name': '(UTC) Monrovia, Reykjavik', 'utcOffset': 0 }, { 'id': 'W. Europe Standard Time', 'name': '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', 'utcOffset': 60 }, { 'id': 'Central Europe Standard Time', 'name': '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', 'utcOffset': 60 }, { 'id': 'Romance Standard Time', 'name': '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', 'utcOffset': 60 }, { 'id': 'Central European Standard Time', 'name': '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', 'utcOffset': 60 }, { 'id': 'W. Central Africa Standard Time', 'name': '(UTC+01:00) West Central Africa', 'utcOffset': 60 }, { 'id': 'Namibia Standard Time', 'name': '(UTC+01:00) Windhoek', 'utcOffset': 60 }, { 'id': 'Jordan Standard Time', 'name': '(UTC+02:00) Amman', 'utcOffset': 120 }, { 'id': 'GTB Standard Time', 'name': '(UTC+02:00) Athens, Bucharest', 'utcOffset': 120 }, { 'id': 'Middle East Standard Time', 'name': '(UTC+02:00) Beirut', 'utcOffset': 120 }, { 'id': 'Egypt Standard Time', 'name': '(UTC+02:00) Cairo', 'utcOffset': 120 }, { 'id': 'Syria Standard Time', 'name': '(UTC+02:00) Damascus', 'utcOffset': 120 }, { 'id': 'E. Europe Standard Time', 'name': '(UTC+02:00) E. Europe', 'utcOffset': 120 }, { 'id': 'South Africa Standard Time', 'name': '(UTC+02:00) Harare, Pretoria', 'utcOffset': 120 }, { 'id': 'FLE Standard Time', 'name': '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', 'utcOffset': 120 }, { 'id': 'Turkey Standard Time', 'name': '(UTC+02:00) Istanbul', 'utcOffset': 120 }, { 'id': 'Israel Standard Time', 'name': '(UTC+02:00) Jerusalem', 'utcOffset': 120 }, { 'id': 'Kaliningrad Standard Time', 'name': '(UTC+02:00) Kaliningrad (RTZ 1)', 'utcOffset': 120 }, { 'id': 'Libya Standard Time', 'name': '(UTC+02:00) Tripoli', 'utcOffset': 120 }, { 'id': 'Arabic Standard Time', 'name': '(UTC+03:00) Baghdad', 'utcOffset': 180 }, { 'id': 'Arab Standard Time', 'name': '(UTC+03:00) Kuwait, Riyadh', 'utcOffset': 180 }, { 'id': 'Belarus Standard Time', 'name': '(UTC+03:00) Minsk', 'utcOffset': 180 }, { 'id': 'Russian Standard Time', 'name': '(UTC+03:00) Moscow, St. Petersburg, Volgograd (RTZ 2)', 'utcOffset': 180 }, { 'id': 'E. Africa Standard Time', 'name': '(UTC+03:00) Nairobi', 'utcOffset': 180 }, { 'id': 'Iran Standard Time', 'name': '(UTC+03:30) Tehran', 'utcOffset': 210 }, { 'id': 'Arabian Standard Time', 'name': '(UTC+04:00) Abu Dhabi, Muscat', 'utcOffset': 240 }, { 'id': 'Azerbaijan Standard Time', 'name': '(UTC+04:00) Baku', 'utcOffset': 240 }, { 'id': 'Russia Time Zone 3', 'name': '(UTC+04:00) Izhevsk, Samara (RTZ 3)', 'utcOffset': 240 }, { 'id': 'Mauritius Standard Time', 'name': '(UTC+04:00) Port Louis', 'utcOffset': 240 }, { 'id': 'Georgian Standard Time', 'name': '(UTC+04:00) Tbilisi', 'utcOffset': 240 }, { 'id': 'Caucasus Standard Time', 'name': '(UTC+04:00) Yerevan', 'utcOffset': 240 }, { 'id': 'Afghanistan Standard Time', 'name': '(UTC+04:30) Kabul', 'utcOffset': 270 }, { 'id': 'West Asia Standard Time', 'name': '(UTC+05:00) Ashgabat, Tashkent', 'utcOffset': 300 }, { 'id': 'Ekaterinburg Standard Time', 'name': '(UTC+05:00) Ekaterinburg (RTZ 4)', 'utcOffset': 300 }, { 'id': 'Pakistan Standard Time', 'name': '(UTC+05:00) Islamabad, Karachi', 'utcOffset': 300 }, { 'id': 'India Standard Time', 'name': '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', 'utcOffset': 330 }, { 'id': 'Sri Lanka Standard Time', 'name': '(UTC+05:30) Sri Jayawardenepura', 'utcOffset': 330 }, { 'id': 'Nepal Standard Time', 'name': '(UTC+05:45) Kathmandu', 'utcOffset': 345 }, { 'id': 'Central Asia Standard Time', 'name': '(UTC+06:00) Astana', 'utcOffset': 360 }, { 'id': 'Bangladesh Standard Time', 'name': '(UTC+06:00) Dhaka', 'utcOffset': 360 }, { 'id': 'N. Central Asia Standard Time', 'name': '(UTC+06:00) Novosibirsk (RTZ 5)', 'utcOffset': 360 }, { 'id': 'Myanmar Standard Time', 'name': '(UTC+06:30) Yangon (Rangoon)', 'utcOffset': 390 }, { 'id': 'SE Asia Standard Time', 'name': '(UTC+07:00) Bangkok, Hanoi, Jakarta', 'utcOffset': 420 }, { 'id': 'North Asia Standard Time', 'name': '(UTC+07:00) Krasnoyarsk (RTZ 6)', 'utcOffset': 420 }, { 'id': 'China Standard Time', 'name': '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi', 'utcOffset': 480 }, { 'id': 'North Asia East Standard Time', 'name': '(UTC+08:00) Irkutsk (RTZ 7)', 'utcOffset': 480 }, { 'id': 'Singapore Standard Time', 'name': '(UTC+08:00) Kuala Lumpur, Singapore', 'utcOffset': 480 }, { 'id': 'W. Australia Standard Time', 'name': '(UTC+08:00) Perth', 'utcOffset': 480 }, { 'id': 'Taipei Standard Time', 'name': '(UTC+08:00) Taipei', 'utcOffset': 480 }, { 'id': 'Ulaanbaatar Standard Time', 'name': '(UTC+08:00) Ulaanbaatar', 'utcOffset': 480 }, { 'id': 'Tokyo Standard Time', 'name': '(UTC+09:00) Osaka, Sapporo, Tokyo', 'utcOffset': 540 }, { 'id': 'Korea Standard Time', 'name': '(UTC+09:00) Seoul', 'utcOffset': 540 }, { 'id': 'Yakutsk Standard Time', 'name': '(UTC+09:00) Yakutsk (RTZ 8)', 'utcOffset': 540 }, { 'id': 'Cen. Australia Standard Time', 'name': '(UTC+09:30) Adelaide', 'utcOffset': 570 }, { 'id': 'AUS Central Standard Time', 'name': '(UTC+09:30) Darwin', 'utcOffset': 570 }, { 'id': 'E. Australia Standard Time', 'name': '(UTC+10:00) Brisbane', 'utcOffset': 600 }, { 'id': 'AUS Eastern Standard Time', 'name': '(UTC+10:00) Canberra, Melbourne, Sydney', 'utcOffset': 600 }, { 'id': 'West Pacific Standard Time', 'name': '(UTC+10:00) Guam, Port Moresby', 'utcOffset': 600 }, { 'id': 'Tasmania Standard Time', 'name': '(UTC+10:00) Hobart', 'utcOffset': 600 }, { 'id': 'Magadan Standard Time', 'name': '(UTC+10:00) Magadan', 'utcOffset': 600 }, { 'id': 'Vladivostok Standard Time', 'name': '(UTC+10:00) Vladivostok, Magadan (RTZ 9)', 'utcOffset': 600 }, { 'id': 'Russia Time Zone 10', 'name': '(UTC+11:00) Chokurdakh (RTZ 10)', 'utcOffset': 660 }, { 'id': 'Central Pacific Standard Time', 'name': '(UTC+11:00) Solomon Is., New Caledonia', 'utcOffset': 660 }, { 'id': 'Russia Time Zone 11', 'name': '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky (RTZ 11)', 'utcOffset': 720 }, { 'id': 'New Zealand Standard Time', 'name': '(UTC+12:00) Auckland, Wellington', 'utcOffset': 720 }, { 'id': 'UTC+12', 'name': '(UTC+12:00) Coordinated Universal Time+12', 'utcOffset': 720 }, { 'id': 'Fiji Standard Time', 'name': '(UTC+12:00) Fiji', 'utcOffset': 720 }, { 'id': 'Kamchatka Standard Time', 'name': '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', 'utcOffset': 720 }, { 'id': 'Tonga Standard Time', 'name': "(UTC+13:00) Nuku'alofa", 'utcOffset': 780 }, { 'id': 'Samoa Standard Time', 'name': '(UTC+13:00) Samoa', 'utcOffset': 780 }, { 'id': 'Line Islands Standard Time', 'name': '(UTC+14:00) Kiritimati Island', 'utcOffset': 840 }];


export const getWindowsTzId =  (tzStar) => {
    if (!tzStar) {
        tzStar = getTzStar();
    }
    return maps[tzStar.toLowerCase()];
};

maps.getWinTzStar = (star) => {
    var name = maps.getWindowsTzId(star);
    // return array(maps.timezones).first(m => m.id == name);

    return maps.timezones.find(m => m.id == name);
};
maps.getWinTzStar = (star) => {
    var name = maps.getWindowsTzId(star);

    return maps.getWinTzByTzId(name);
};

maps.getWinTzByTzId = (name) => {
    // return array(maps.timezones).first(m => m.id == name);
    return maps.timezones.find(m => m.id == name);
};
export const getTzStar = (name) => {
    if (name) {
        if (name == 'Pacific Standard Time (Mexico)') {
            return 'america/los_angeles';
        }
        if (name == 'Mid-Atlantic Standard Time') {
            return 'etc/gmt+2';
        }
        if (name == 'Kamchatka Standard Time') {
            return 'etc/gmt-12';
        }
        name = name.toLowerCase();
        for (var i in maps) {
            if (!maps[i]) {
                continue;
            }
            var s = maps[i];
            // if (system.isString(s)) {

                if (typeof s === 'string') {
                if (s.toLocaleLowerCase() == name) {
                    return i;
                }
            }
        }
    }
    var tz = determine();

    return tz.name();
};
export const getUtcOffset = (timeZoneId, dateLocal) => {
    const tz_star = getTzStar(timeZoneId);

    return moment(dateLocal).tz(tz_star).utcOffset();
};

export const convertToLocalTime = (dateUTC, timeZoneId, format) => {
    if (!dateUTC) return '';
    return moment(dateUTC).tz(getTzStar(timeZoneId)).format(format || 'YYYY-MM-DDTHH:mm:ss[Z]') || moment().utc().format();
};

export const convertToUTC = (dateLocal, timeZoneId, format) => {
    const time_zone_utc_offset_minutes = getUtcOffset(timeZoneId, dateLocal);

    return moment(dateLocal)
        .utcOffset(-time_zone_utc_offset_minutes)
        .format(format || 'YYYY-MM-DDTHH:mm:ss[Z]')
        || moment().utc().format();
};
